import BaseFormItem from "../BaseFormItem";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import PropTypes from "prop-types";
import entityFieldMetaStore from "data/meta/entityFieldMetaStore";
import ChoiceStore from "data/meta/ChoiceStore";
import { optionsForField } from "data/selectors/options";
import React from "react";
import Control from "lib/common/descriptorcontrols/ChoiceField/typeahead";

const DEFAULT_VALUE_KEY = "name";
const DEFAULT_LABEL_KEY = "label";

const inflateValue = (config, options, v) => {
    const valueKey = config.valueKey || DEFAULT_VALUE_KEY;
    const findValue = val => options.find(it => val === it[valueKey]);

    if(v !== null) {
        if(config.multiValued) {
            // find in options array
            v = v.map(it => findValue(it))
                .filter(it => it);
        }
        else {
            v = findValue(v);
        }
    }
    return v;
};

export class ChoiceFieldtypeahead extends BaseFormItem {

    constructor(props) {
        super(props);
        const { activeRecord, descriptor } = props;
        // these can't change
        this.info = entityFieldMetaStore.getInfo(
            activeRecord.entityKey,
            descriptor.key,
        );
        this.choice = ChoiceStore.getChoiceByKey(this.info.choiceKey);
        this.conditional = this.info.conditions && this.info.conditions.length > 0;
        this.__enablePureOverValueAndEnabledHandling();
    }

    onCommitChange(d, v, userInvoked = true, label = null) {
        const {descriptor} = this.props;
        const config = descriptor.config || {};
        const valueKey = config.valueKey || DEFAULT_VALUE_KEY;
        // deflate value
        if (config.multiValued) {
            if (Array.isArray(v)) {
                v = v.map((it) => it[valueKey]);
            } else {
                v = null;
            }
        } else {
            v = (v === null) ? null : v[valueKey];
        }
        super.onCommitChange(d, v, userInvoked, label);
    }

    render() {
        const { value, enabled } = this.state;
        const { descriptor } = this.props;
        const config = descriptor.config || {};
        const valueKey = config.valueKey || DEFAULT_VALUE_KEY;
        const labelKey = config.labelKey || DEFAULT_LABEL_KEY;
        const options = optionsForField(
            this.info,
            this.conditional ? this.props.activeRecord : null,
            this.choice,
            true,
        );
        return <Control
            {...this.getPlumbingProps()}
            valueKey={valueKey}
            labelKey={labelKey}
            options={options}
            value={inflateValue(
                config,
                options,
                value,
            )}
            enabled={enabled}
            onCommitChange={this.onCommitChange}
        />;
    }

}

ChoiceFieldtypeahead.propTypes = {
    ...ChoiceFieldtypeahead.propTypes,
    descriptor: PropTypes.shape(descriptorPropTypes({
        multiValued: PropTypes.bool.isRequired
    })),
};

export default ChoiceFieldtypeahead;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/ChoiceField/typeahead.js